import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-ng-select',
  template: `
    <ng-select  [items]="to.options | sort:labelProp"
      class="customSelect"
      [bindLabel]="labelProp"
      [bindValue]="valueProp"
      [multiple]="to.multiple"
      [virtualScroll]="true"
      [loading]="false"
      [placeholder]="to.placeholder"
      [formControl]="formControl"
      [formlyAttributes]="field">
      <ng-template ng-option-tmp let-item="item" *ngIf="to?.tooltip">
      <div [tooltip]="item.text+' : '+tool(item.id)">{{ item.text }}</div>
      </ng-template>
    </ng-select>
  `,
})
export class FormlyFieldSelect extends FieldType {
  get labelProp(): string { 
    return this.to.labelProp ||  'text' }
  get valueProp(): string { 
    return this.to.valueProp || 'id' }
  
     tool(value){
      return  this.to.tooltip.find((x) => x.id == value).text
    }
}